/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDeliveryDrivers200ResponseAllOfData } from './GetDeliveryDrivers200ResponseAllOfData';
import {
    GetDeliveryDrivers200ResponseAllOfDataFromJSON,
    GetDeliveryDrivers200ResponseAllOfDataFromJSONTyped,
    GetDeliveryDrivers200ResponseAllOfDataToJSON,
} from './GetDeliveryDrivers200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetDeliveryDrivers200Response
 */
export interface GetDeliveryDrivers200Response {
    /**
     * 
     * @type {GetDeliveryDrivers200ResponseAllOfData}
     * @memberof GetDeliveryDrivers200Response
     */
    data: GetDeliveryDrivers200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetDeliveryDrivers200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetDeliveryDrivers200Response interface.
 */
export function instanceOfGetDeliveryDrivers200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetDeliveryDrivers200ResponseFromJSON(json: any): GetDeliveryDrivers200Response {
    return GetDeliveryDrivers200ResponseFromJSONTyped(json, false);
}

export function GetDeliveryDrivers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryDrivers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetDeliveryDrivers200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetDeliveryDrivers200ResponseToJSON(value?: GetDeliveryDrivers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetDeliveryDrivers200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

